import * as React from 'react';
import {useParams} from 'react-router-dom';
import {addCharge} from "../../../api";
import {useEffect, useState} from "react";
import {useHistory} from "react-router";


const AddCharge: React.FunctionComponent = () => {

    const {clientId} = useParams();
    const [amount, setAmount] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [description, setDescription] = useState("");
    const [doSearchRedirect, setDoSearchRedirect] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (doSearchRedirect) {
            history.push({
                pathname: "/m/clients/view/" + clientId
            });
        }
    }, [doSearchRedirect, history, clientId]);

    const doAdd = () => {
        addCharge(clientId, {
            amount: amount,
            chargeDate: createdAt,
            description: description
        }).then((c) => {
            setDoSearchRedirect(true);
        })
    }

    return (<>
        <form>
            <div className={"row"}>
                <div className={"col-lg-12 mb-3 "}>
                    <h2>Add Charge</h2>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <h6>Item Details</h6>
                </div>
                <div className={"col-lg-12 mb-3 "}>

                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Item</label>
                            <select id="inputState" className="form-control"
                                    value={description} onChange={(e) => setDescription(e.target.value)}>
                                <option value={""} disabled={true}>Choose...</option>
                                <option value={"Assessment"}>Assessment</option>
                                <option value={"Therapy session"}>Therapy session</option>
                                <option value={"Other"}>Other</option>
                            </select>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label htmlFor="inputEmail4">Amount</label>
                            <input type="number" className="form-control" id="inlineFormInputName"
                                   value={amount} onChange={(e) => setAmount(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Transaction Date</label>
                            <input type="date" className="form-control" id="inlineFormInputName"
                                   value={createdAt} onChange={(e) => setCreatedAt(e.target.value)}/>
                        </div>
                    </div>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <button type={"submit"} className={"btn btn-danger mr-3"}
                            onClick={(e) => {
                                e.preventDefault();
                                setDoSearchRedirect(true);
                            }}>Cancel
                    </button>
                    <button type={"submit"} className={"btn btn-primary"}
                            onClick={(e) => {
                                e.preventDefault();
                                doAdd();
                            }}>Save
                    </button>
                </div>

            </div>
        </form>
    </>);
};

export default AddCharge;